export default {
    "en": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "branches": {
            "add": "Add branch",
            "edit": "Edit branch",
            "delete": "Delete branch",
            "not_find": "Can not find branch with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the branch's name",
            "business_name": "Business name",
            "business_name_placeholder": "Enter the branch's business name",
            "address": "Address",
            "address_name_placeholder": "Enter the branch's address",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Branches Report"
        },
        "contacts": {
            "add": "Add contact",
            "edit": "Edit contact",
            "delete": "Delete contact",
            "not_find": "Can not find contact with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the contact's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Contacts Report",
            "position": "Position",
            "position_placeholder": "Enter the contact's position",
            "customer_id": "Customer",
            "customer_supplier": "Customer/Supplier",
            "phone": "Phone",
            "phone_placeholder": "Enter the contact's phone",
            "customer_placeholder": "Enter the contact's customer",
            "email": "Email",
            "email_placeholder": "Enter the contact's email"
        },
        "customer_addresses": {
            "add": "Add Address",
            "edit": "Edit Address",
            "delete": "Delete Address",
            "not_find": "Can not find Address with this code.",
            "id": "Id",
            "address_name": "Name",
            "address_name_placeholder": "Enter the address's name",
            "street_name": "Street",
            "street_name_placeholder": "Enther the address's street",
            "street_number": "Number",
            "street_number_placeholder": "Enter the address's number",
            "city": "City",
            "city_placeholder": "Enter the address's city",
            "state": "State",
            "state_placeholder": "Enter the address's state",
            "country": "Country",
            "country_placeholder": "Enter the address's country",
            "zip_code": "Zip Code",
            "zip_code_placeholder": "Enter the address's zip code",
            "customer_display": "Customer",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "CustomerAddresses Report"
        },
        "customer_purchase_order_details": {
            "add": "Add customerPurchaseOrderDetail",
            "edit": "Edit customerPurchaseOrderDetail",
            "delete": "Delete customerPurchaseOrderDetail",
            "not_find": "Can not find customerPurchaseOrderDetail with this code.",
            "on_time": "On Time",
            "mistime": "Mistime",
            "cancelled": "Cancelled",
            "delivered": "Delivered",
            "id": "#",
            "purchase_order_display": "Purchase Order",
            "purchase_order_id": "Purchase Order ID",
            "name": "Name",
            "name_placeholder": "Enter the customerPurchaseOrderDetail's name",
            "quantity": "Quantity",
            "unit_price": "Unit Price",
            "amount": "Amount",
            "delivery_status": "Status",
            "production_status_display": "Production Status",
            "production_status_placeholder": "Select the production estatus",
            "production_area_display": "Production Area",
            "production_area_placeholder": "Select the production area",
            "currency_display": "Currency",
            "customer_display": "Customer",
            "delivery_time": "Delivery Time",
            "delivery_time_placeholder": "Type the delivery time",
            "delivery_date": "Delivery Date",
            "delivery_date_placeholder": "Type the delivery date",
            "destination": "Destination",
            "destination_placeholder": "Type the destination",
            "folio": "Folio",
            "requisitor": "Requisitor",
            "invoiced_amount": "Invoiced Amount",
            "amount_to_invoice": "Amount to Invoice",
            "total_import": "Total",
            "subtotal": "Subtotal",
            "tax": "Tax",
            "total_with_tax": "Total Import",
            "notes": "Notas",
            "number": "No. de Orden",
            "created_at": "Created at",
            "report_title": "CustomerPurchaseOrderDetails Report",
            "without_process_date": "Without process date",
            "in_progress_date": "In process date",
            "stoped_date": "Stoped date",
            "forged_date": "Forged date",
            "fold_die_cut_date": "Fol and die cut date",
            "enabled_date": "Enabled date",
            "paint_date": "Paint date",
            "finished_date": "Finished date",
            "customer": "Customer",
            "production_area": "Production Area",
            "production_status": "Production Status",
            "currency": "Currency",
            "status": "Status",
            "product": "Product",
            "payments": "Payments"
        },
        "customer_purchase_orders": {
            "add": "Add customer Purchase Order",
            "edit": "Edit customer Purchase Order",
            "delete": "Delete customer Purchase Order",
            "not_find": "Can not find customer Purchase Order with this code.",
            "sended": "Sended",
            "completed": "Completed",
            "pending": "Pending",
            "cancelled": "Cancelled",
            "partially_stocked": "Partially Stocked",
            "authorized": "Authorized",
            "id": "Id",
            "number": "Purchase Order",
            "number_placeholder": "Enter the Purchase Order's number",
            "customer_display": "Customer",
            "project_display": "Project",
            "folio": "Folio",
            "folio_placeholder": "Enter the Purchase Order'sfolio",
            "currency_display": "Currency",
            "exchange_rate": "Exchange Rate",
            "exchange_rate_placeholder": "Enter the exchange rate",
            "requisitor": "Requisitor",
            "requisitor_placeholder": "Enter the requisitor",
            "tax_type": "Tax Type",
            "tax_amount": "Tax Amount",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Customer Purchase Orders Report",
            "quantity": "Quantity",
            "production_status_display": "Production status",
            "production_area_display": "Production Area",
            "delivery_status": "Time",
            "destination": "Destination",
            "unit_price": "Unit Price",
            "amount": "Amount",
            "name": "Description",
            "note": "Note",
            "delivery_date": "Delivery Date",
            "invoiced_amount": "Invoiced amount",
            "amount_to_invoice": "Amount to invoice",
            "payment_deadline": "Payment Deadline",
            "payment_deadline_placeholder": "Select the payment deadline"
        },
        "customers": {
            "add": "Add customer",
            "edit": "Edit customer",
            "delete": "Delete customer",
            "not_find": "Can not find customer with this code.",
            "quotation_with_customer": "The Customer can not be deleted, there are quotations with this Customer",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the customer's name",
            "status": "Status",
            "created_at": "Created at",
            "business_name": "Business name",
            "report_title": "Customers Report",
            "business_name_placeholder": "Enter the customer's business name",
            "phone": "Phone",
            "phone_name_placeholder": "Enter the customer's phone",
            "email": "Email",
            "email_name_placeholder": "Enter the customer's email",
            "rfc": "RFC",
            "rfc_name_placeholder": "Enter the customer's rfc",
            "address": "Address",
            "address_name_placeholder": "Enter the customer's address",
            "without_invoices": "The customer has not invoices with "
        },
        "errors": {
            "fatal_error": "A fatal error occurred, please contact us.",
            "generic_error": "An error occurred, please try again.",
            "unauthorized": "Unauthorized.",
            "forbidden": "Forbidden.",
            "connection_error": "Connection error",
            "action_unauthorized": "This action is unauthorized."
        },
        "feedback": {
            "rate": "What do you think of this experience?",
            "comment": "Tell us how was your experience?",
            "contact_me": "Controlla can contact me about my feedback."
        },
        "front": {
            "values": "Values",
            "added_successfully": "It has been added successfully.",
            "updated_successfully": "It has been updated successfully.",
            "deleted_successfully": "It has been deleted successfully.",
            "imported_successfully": "It has been imported successfully.",
            "delete_modal": "Delete",
            "delete_confirmation": "Are you sure you want to delete the {model} {attribute}?",
            "delete_confirmation2": "Are you sure you want to delete {model} {attribute}?",
            "action_confirmation": "Are you sure you want to {action} this {model}?",
            "action_confirmation2": "Are you sure you want to {action} this {model}?",
            "import_modal": "Import {model} from CSV or Excel file"
        },
        "invoiced_products": {
            "add": "Add invoicedProduct",
            "edit": "Edit invoicedProduct",
            "delete": "Delete invoicedProduct",
            "not_find": "Can not find invoicedProduct with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the invoicedProduct's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "InvoicedProducts Report"
        },
        "invoices": {
            "add": "Add invoice",
            "edit": "Edit invoice",
            "delete": "Delete invoice",
            "not_find": "Can not find invoice with this code.",
            "paid": "Paid",
            "partially_paid": "Partially Paid",
            "pending": "Pending",
            "1": "Yes",
            "0": "No",
            "detail": "Invoice Detail",
            "id": "Pre Invoice",
            "number": "Number",
            "number_placeholder": "Enter the invoice's number",
            "purchase_order_display": "Purchase Order",
            "date": "Date",
            "discount": "Discount",
            "discount_placeholder": "Type the Discount",
            "amount": "Amount",
            "currency": "Currency",
            "status": "Status",
            "total": "Total",
            "subtotal_amount": "Subtotal",
            "compaq": "Folio Compaq",
            "compaq_placeholder": "Type the compaq folio",
            "tax_receipt_display": "CFDI",
            "cfdi_placeholder": "Select the CFDI",
            "late_payment": "Late Payment",
            "portal_date": "Portal Date",
            "signature": "Signature",
            "comments": "Comments",
            "payment_deadline": "Payment Deadline",
            "customer_display": "Customer",
            "created_at": "Created at",
            "user_display": "Created By",
            "report_title": "Invoices Report",
            "type": "Type",
            "tax_amount": "Tax",
            "subtotal": "Subtotal",
            "currency_payment": "Currency",
            "project": "Project"
        },
        "login": {
            "email": "Email",
            "password": "Password",
            "keep_connected": "Keep connected",
            "forgot_password": "Forgot password",
            "login": "Login",
            "logout": "Logout",
            "reset_password": "Reset password",
            "send_reset_link": "Send the reset link",
            "password_confirmation": "Password confirmation",
            "still_having_trouble": "Still having trouble logging in?",
            "havent_account": "Don't have a account?",
            "back_login": "Back to login",
            "register": "Create account",
            "welcome": "Welcome",
            "description": "Description app"
        },
        "notifications": {
            "empty_title": "No notifications at this time",
            "empty_msg": "When your team starts doing things, we will show the notifications here.",
            "add_new_user": "New User!",
            "add_new_user_message": "has added a new user"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "cant_login": "Can't you login?",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "payments": {
            "add": "Add payment",
            "edit": "Edit payment",
            "delete": "Delete payment",
            "not_find": "Can not find payment with this code.",
            "transfer": "Transfer",
            "check": "Check",
            "other": "Other",
            "cash": "Cash",
            "1": "Banorte",
            "2": "Banregio",
            "3": "Intercam",
            "4": "Monex",
            "id": "Id",
            "invoice_display": "Invoice",
            "invoice_placeholder": "Enter the payment's invoice",
            "amount": "Amount",
            "amount_placeholder": "Enter the amount",
            "total": "Total",
            "total_placeholder": "Enter the payment's total",
            "subtotal": "Subtotal",
            "tax_amount": "Tax Amount",
            "date": "Date",
            "date_placeholder": "Enter the payment's date",
            "type": "Type",
            "type_placeholder": "Select the type of payment",
            "receipt": "Receipt",
            "receipt_placeholder": "Enter the payment's receipt",
            "bank": "Bank",
            "bank_placeholder": "Select the Bank",
            "created_at": "Created at",
            "report_title": "Payments Report",
            "user_display": "Created By"
        },
        "production_areas": {
            "add": "Add Production Area",
            "edit": "Edit Production Area",
            "delete": "Delete Production Area",
            "not_find": "Can not find Production Area with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the Production Area's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Production Areas Report"
        },
        "production_statuses": {
            "add": "Add production Status",
            "edit": "Edit production Status",
            "delete": "Delete production Status",
            "not_find": "Can not find production Status with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the production Status's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Production Statuses Report"
        },
        "products": {
            "add": "Add products",
            "edit": "Edit products",
            "delete": "Delete products",
            "not_find": "Can not find products with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the products's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Products Report",
            "sku": "Sku",
            "category": "Category",
            "category_id": "Category",
            "unit_price": "Unit Price",
            "unit_price_placeholder": "Type the Unit Price"
        },
        "projects": {
            "add": "Add project",
            "edit": "Edit project",
            "delete": "Delete project",
            "not_find": "Can not find project with this code.",
            "add_purchase_order": "Add Purchase Order",
            "in_progress": "In Progress",
            "finished": "Finished",
            "id": "Invoice",
            "name": "Name",
            "name_placeholder": "Enter the project's name",
            "customer_display": "Customer",
            "customer_placeholder": "Enter the customer's name",
            "total_amount": "Total Amount",
            "total_amount_placeholder": "Enter the total amount",
            "tax": "Tax",
            "tax_placeholder": "Enter the tax",
            "delivery_address": "Delivery Address",
            "delivery_address_placeholder": "Enter the delivery address",
            "authorization_date": "Authorization Date",
            "authorization_date_placeholder": "Enter the authorization date",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Projects Report",
            "total_amount_paid": "Total amout paid",
            "invoices_usd": "Income invoices USD",
            "invoices_mxn": "Income invoices MXN",
            "pending_amount": "Amount pending billing",
            "billed_balance": "Billed balance",
            "balance_paid": "Balance paid",
            "Balance_to_be_billed": "Balance to be billed",
            "subtotal_amount": "Amount without VAT",
            "total_without_iva": "Total of the project without VAT",
            "total_amount_invoice_without_iva": "Total Amount Invoice without VAT",
            "total_amount_paid_without_iva": "Total amout paid without VAT",
            "pending_amount_without_iva": "Amount pending billing without VAT",
            "total": "Total del proyecto",
            "total_amount_invoice": "Total Amount Invoice",
            "show_iva": "see with vat"
        },
        "purchase_orders": {
            "add": "Add purchaseOrder",
            "edit": "Edit purchaseOrder",
            "delete": "Delete purchaseOrder",
            "not_find": "Can not find purchaseOrder with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the purchaseOrder's name",
            "status": "Status",
            "send": "Sended",
            "authorize": "Authorize",
            "send_order": "Send Order",
            "authorize_order": "Authorize Order",
            "cancel_order": "Cancel Order",
            "sended": "Sended",
            "completed": "Completed",
            "pending": "Pending",
            "cancelled": "Cancelled",
            "cancel": "Cancelled",
            "partially_stocked": "Partially stocked",
            "authorized": "Authorized",
            "cancel_error": "Purchase Order already cancelled",
            "sended_error": "Purchase Order already sended",
            "created_at": "Created at",
            "report_title": "PurchaseOrders Report",
            "folio": "Invoice",
            "folio_placeholder": "Enter the invoice",
            "project_display": "Project",
            "project_placeholder": "Enter the name of the project",
            "supplier_display": "Supplier",
            "supplier_placeholder": "Enter the supplier name",
            "user_display": "Created by",
            "email": "Email address",
            "email_placeholder": "Enthe the email",
            "shipping_address": "Shipping Address",
            "shipping_address_placeholder": "Enter the shipping address",
            "delivery_time": "Delivery time",
            "delivery_time_placeholder": "Enter the delivery time",
            "deadline": "Deadline",
            "deadline_placeholder": "Enter the deadline",
            "freight": "Freight",
            "freight_placeholder": "Select the Freight",
            "notes": "Notes",
            "notes_placeholder": "Enter the notes",
            "summary": "Summary",
            "download_all_pdf": "Dowload all PDF",
            "download_pdf": "Dowload PDF",
            "information": "Review the detailed information before downloading your file.",
            "exit": "Exit Purchase Order",
            "supply_amount": "Supply amount",
            "supply_unit": "Supply Unit",
            "supply": "Product",
            "supply_order_quantity": "Order",
            "user": "User",
            "supply_pending_quantity": "Cant",
            "remaining": "Remaining",
            "for_recieving": "For Recieving",
            "to_receive": "To receive",
            "number": "Invoice number",
            "number_placeholder": "Enter the Invoice number",
            "placeholder_justify": "Justify the reason for closing this request",
            "justify": "Justify",
            "supply_description": "Product",
            "currency": "Moneda",
            "tax_type": "Tax Type",
            "tax_amount": "Tax Amount",
            "product": "Producto",
            "description": "Description",
            "unit_of_measurement": "Unit",
            "quantity": "Quantity",
            "projects": "Projects",
            "suppliers": "Suppliers"
        },
        "quotations": {
            "add": "Add quotation",
            "edit": "Edit quotation",
            "delete": "Delete quotation",
            "not_find": "Can not find quotation with this code.",
            "authorized_error": "Quotation already authorized",
            "authorize": "Authorized",
            "authorize_title": "Authorize Quotation",
            "id": "Id",
            "name": "Name",
            "project": "Project",
            "name_placeholder": "Enter the quotation's name",
            "customer": "Customer",
            "customer_placeholder": "Enter the quotation's customer",
            "contact": "Contact",
            "contact_placeholder": "Enter the quotation's contact",
            "currency": "Currency",
            "currency_placeholder": "Enter the quotation's name",
            "address": "Address",
            "address_placeholder": "Enter the quotation's address",
            "payment_conditions": "Payment Conditions",
            "payment_conditions_placeholder": "Enter the quotation's Payment Conditions",
            "tax_type": "tax_type",
            "tax_type_placeholder": "Enter the quotation's Tax",
            "tax_amount": "Tax Amount",
            "product_id": "Product",
            "product_id_placeholder": "Enter the quotation's Product",
            "product": "Product",
            "product_placeholder": "Enter the quotation's Product",
            "price_neto": "Price neto",
            "price_neto_placeholder": "Enter the quotation's Price",
            "quantity": "Quantity",
            "quantity_placeholder": "Enter the quotation's Quantity",
            "amount": "Amount",
            "amount_placeholder": "Enter the quotation's Amount",
            "status": "Status",
            "folio": "Folio",
            "authorized": "Authorized",
            "cancelled": "Cancelled",
            "pending": "Pending",
            "action": " ",
            "total": "Total",
            "totals": "Totals",
            "subtotal": "Subtotal",
            "total_amount": "Total amount",
            "quotation_total": "Total amount",
            "folio_placeholder": "Enter the quotation's Folio",
            "created_by": "Created by",
            "delivery_date": "Delivery date",
            "destination": "Destination",
            "created_at": "Created at",
            "report_title": "Quotations Report",
            "previous": "Previous",
            "next": "Next",
            "save": "Save",
            "step_one": "Step 1",
            "master_data": "Master data",
            "master_data_description": "Complete the following information about the project you want to quote.",
            "step_two": "Step 2",
            "details_data": "Details data",
            "step_three": "Step 3",
            "extra_information": "Extra information",
            "attached_file": "Attached file",
            "notes": "Notes",
            "write_here": "Write here",
            "description_attached": "Drag or import Excel files",
            "summary": "Summary",
            "step_four": "Step 4",
            "description_four": "Review the detailed information before downloading your file.",
            "download_pdf": "Download pdf",
            "progress": "In Progress",
            "complete": "Complete",
            "clean_table": "Clean table",
            "add_requisite": "Add Requisite",
            "requisite": "Requisite",
            "requisiteres": "Requisiteres",
            "requisite_placeholder": "Enter the quotation's requisite",
            "add_branche": "Add branche",
            "branche": "branche",
            "branches": "branches",
            "branche_placeholder": "Enter the quotation's branche",
            "clone": "Clone",
            "unit_price": "unit price",
            "download_template": "Download template",
            "exchange_rate": "Exchange rate",
            "exchange_rate_placeholder": "Enter the quotation's Exchange rate",
            "total_freight": "Total freight",
            "add_contact": "Add contact",
            "additional_conditions": "Additional Conditions",
            "description": "Description",
            "unit": "Unit"
        },
        "reception_details": {
            "add": "Add receptionDetail",
            "edit": "Edit receptionDetail",
            "delete": "Delete receptionDetail",
            "not_find": "Can not find receptionDetail with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the receptionDetail's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "ReceptionDetails Report"
        },
        "receptions": {
            "add": "Add reception",
            "edit": "Edit reception",
            "delete": "Delete reception",
            "not_find": "Can not find reception with this code.",
            "receptioned": "Receptioned",
            "cancelled": "Cancelled",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the reception's name",
            "folio": "Folio",
            "purchase_order_display": "Purchase Order",
            "product_amount": "Product Amount",
            "reception_date": "Reception Date",
            "user_display": "Created by",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Receptions Report",
            "invoice_number": "Invoice Number"
        },
        "register": {
            "title": "Sign up to get your account",
            "email": "Email",
            "name": "Username",
            "password": "Password",
            "register": "Create account",
            "message": "By registering, confirm that you have read and accepted our  <a href=\"/login\"> Terms of use </a> and our <a href=\"/login\"> Privacy policy </a>.",
            "back_login": "Already have an Controlla account? Log in",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "requisition_details": {
            "add": "Add requisitionDetail",
            "edit": "Edit requisitionDetail",
            "delete": "Delete requisitionDetail",
            "not_find": "Can not find requisitionDetail with this code.",
            "supply_id": "Supply Id",
            "supply_display": "Supply",
            "supply_placeholder": "Select supply",
            "supply_amount_display": "Supply amount",
            "supply_amount_placeholder": "Insert supply amount",
            "supply_order_quantity_display": "Supply order quantity",
            "supply_order_quantity_placeholder": "Insert supply order quantity",
            "supply_pending_quantity_display": "Supply pending quantity",
            "supply_pending_quantity_placeholder": "Insert supply pending quantity",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the requisitionDetail's name",
            "supply_description": "Supply Description",
            "supply_unit": "Supply Unit",
            "supply_amount": "Supply Amount",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "RequisitionDetails Report"
        },
        "requisitioners": {
            "add": "Add requisitioner",
            "edit": "Edit requisitioner",
            "delete": "Delete requisitioner",
            "not_find": "Can not find requisitioner with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the requisitioner's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "requisitioners Report"
        },
        "requisitions": {
            "add": "Add requisition",
            "edit": "Edit requisition",
            "delete": "Delete requisition",
            "not_find": "Can not find requisition with this code.",
            "id": "#",
            "name": "Name",
            "name_placeholder": "Enter the requisition's name",
            "status": "Status",
            "pending": "Pending",
            "accepted": "Accepted",
            "closed": "Closed",
            "created_at": "Created at",
            "report_title": "Requisitions Report",
            "folio": "Invoice",
            "folio_placeholder": "Enter the invoice",
            "project_display": "Project",
            "project_placeholder": "Enter the name of the project",
            "product_amount": "Num. of products",
            "product_amount_placeholder": "Enter the number of products",
            "user_display": "Created by"
        },
        "requisitions_mailboxes": {
            "add": "Add requisitionsMailbox",
            "edit": "Edit requisitionsMailbox",
            "delete": "Delete requisitionsMailbox",
            "not_find": "Can not find requisitionsMailbox with this code.",
            "id": "#",
            "name": "Name",
            "name_placeholder": "Enter the requisitionsMailbox's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "RequisitionsMailboxes Report",
            "requisitions_mailboxes": "Requisitions Mailboxes",
            "folio": "Folio",
            "project": "Project",
            "product_amount": "No. Products",
            "products": "Productos",
            "product": "Product",
            "supply_amount": "Supply amount",
            "supply_unit": "Supply Unit",
            "supply": "Product",
            "supply_order_quantity": "Order",
            "user": "User",
            "supply_pending_quantity": "Cant",
            "filter": "Search by product or SKU:",
            "end_session": "End sesión",
            "create_order": "Create Order",
            "end_order": "Finalizar orden",
            "action": " ",
            "continue_editing": "Edit",
            "edit_later": "Edit later",
            "almacen": "move to storage",
            "unit_price": "Unit price",
            "total": "Total"
        },
        "reset": {
            "subject": "Reset your Controlla Password",
            "line_1": "You are receiving this email because we received a password reset request for your account.",
            "action": "Reset Password",
            "line_2": "This password reset link will expire in {count} minutes.",
            "line_3": "If you did not request a password reset, no further action is required."
        },
        "strings": {
            "dashboard": "Dashboard",
            "overview": "Overview",
            "user": "User",
            "users": "Users",
            "report": "Report",
            "branch": "Branch",
            "branches": "Branches",
            "customer": "Customer",
            "customers": "Customers",
            "customer_address": "Address",
            "customer_addresses": "Addresses",
            "customer_purchase_order": "Customer Purchase Order",
            "customer_purchase_orders": "Customer Purchase Orders",
            "customer_purchase_order_detail": "Customer Purchase Order Detail",
            "customer_purchase_order_details": "Customer Purchase Order Details",
            "customer_oc": "O.C. Customer",
            "invoice_detail": "Invoice Detail",
            "supplier_oc": "O.C. Supplier",
            "quotation": "Quotation",
            "quotations": "Quotations",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "production_area": "Production Area",
            "production_areas": "Production Areas",
            "purchase_order": "Purchase Order",
            "purchase_orders": "Purchase Orders",
            "oc_number": "# O.C.",
            "sale": "Venta",
            "sales": "Ventas",
            "supply": "Supply",
            "supplies": "Supplies",
            "supplier": "Proveedor",
            "supplier_invoice": "Invoice",
            "suppliers": "Proveedores",
            "payment": "Payment",
            "payments": "Payments",
            "production_status": "Production Status",
            "production_statuses": "Production Statuses",
            "product": "Producto",
            "products": "Productos",
            "mining_group": "Grupo Minero",
            "mining_groups": "Grupos Mineros",
            "project": "Project",
            "projects": "Projects",
            "requisitioners": "Requisitioners",
            "requisitioner": "Requisitioner",
            "requisition": "Requisition",
            "requisitions": "Requisitions",
            "requisition_detail": "Requisition Detail",
            "requisition_details": "Requisition Details",
            "id": "id",
            "amount": "Total",
            "description": "An Overview of your {attribute}",
            "search": "Search {attribute} by{columns} or {column}",
            "filters": "Filters",
            "clear": "Clear",
            "apply": "Apply",
            "select_date": "Select a date",
            "multiple": "Multiple",
            "display_list": "Display list",
            "display_grid": "Display grid (enabled)",
            "print": "Print",
            "delete": "Delete",
            "add": "Add",
            "addDetail": "Add Detail",
            "edit": "Edit",
            "save": "Save",
            "accept": "Accept",
            "cancel": "Cancel",
            "view": "View",
            "download": "Download",
            "authorized": "Authorized",
            "import": "Import",
            "import_excel": "Import Excel",
            "export": "Export",
            "registered_on": "Registered on",
            "order_by": "Order by",
            "options": "More options",
            "notifications": "Notifications",
            "messages": "Messages",
            "no_notifications": "No notifications",
            "no_messages": "No messages",
            "see_all": "See all",
            "exit": "Exit",
            "feedback": "Feedback",
            "give_feedback": "Give feedback",
            "shortcuts": "Shortcuts",
            "close_modal": "Close modal",
            "create": "Create resource",
            "view_selected": "View selected",
            "edit_selected": "Edit selected",
            "view_notifications": "View notifications",
            "find": "find",
            "register": "Register",
            "inition": "Inition",
            "commercial": "Commercial",
            "purchases": "Purchases",
            "catalogs": "Catalogs",
            "cancelled": "Cancelled",
            "sold": "Sold",
            "invoiced": "Invoiced",
            "paid": "Paid",
            "pending": "Pending",
            "approved": "Approved",
            "received": "Received",
            "send": "Sent",
            "status": "Status",
            "action_sold": "Sell",
            "action_invoiced": "Invoice",
            "action_paid": "Pay",
            "action_approved": "Approved",
            "action_received": "Received",
            "action_send": "Send",
            "action_active": "Active",
            "action_inactive": "Inactive",
            "contacts": "Contacts",
            "contact": "Contact",
            "add_contacts": "Add contacts",
            "requisitions_mailboxes": "Requisitions Mailboxes",
            "reception": "Reception",
            "receptions": "Receptions",
            "warehouse_receptions": "Warehouse Receptions",
            "warehouse_receptions_description": "Enter the suppliers Folio number to search for the desired order",
            "invoice": "Invoice",
            "invoices": "Invoices",
            "add_invoice": "Add Invoice",
            "total_invoice": "Total Invoice",
            "total_payment": "Total Payment",
            "total_remaining": "Total Remaining",
            "invoice_details": "Invoice Details",
            "manufacturing": "Manufacturing",
            "supplier_invoices": "Supplier Invoices",
            "customer_invoices": "Customer Invoices",
            "income": "Income",
            "expenses": "Expenses",
            "difference": "Difference",
            "quoted": "Quoted",
            "authorized_quotes": "Authorized Quotes",
            "open_quotes": "Open Quotes",
            "quoted_vs_authorized": "Quoted vs Authorized",
            "search_by_date": "Search by Date",
            "date": "Date",
            "total_purchase_orders": "Total Purchase Orders",
            "total": "Total",
            "total_hired": "Total Hired",
            "currency": "Currency",
            "balance": "Balance",
            "search_by_customer": "Search by Customer",
            "payments_vs_invoices": "Payments vs Invoices",
            "payed": "Payed"
        },
        "supplier_invoices": {
            "add": "Add supplierInvoice",
            "edit": "Edit supplierInvoice",
            "delete": "Delete supplierInvoice",
            "not_find": "Can not find supplierInvoice with this code.",
            "paid": "Paid",
            "partial": "Partially Paid",
            "pending": "Pending",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the supplierInvoice's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "SupplierInvoices Report",
            "invoice_number": "Invoice Number",
            "invoice_number_placeholder": "Enter the Invoice Amount",
            "amount": "Amount to invoice",
            "invoice_date": "Date",
            "total_invoice": "Total to invoice",
            "amount_placeholder": "Enter the Amount",
            "supplier": "Supplier",
            "cash": "Efectivo",
            "card": "Tarjeta",
            "transfers": "Trasferencia",
            "payment_type_placeholder": "Selected payment type",
            "payment_type": "Payment type",
            "subtotal": "Subtotal",
            "tax_amount": "Tax",
            "currency": "Moneda"
        },
        "supplier_payments": {
            "add": "Add Payment",
            "edit": "Edit Payment",
            "delete": "Delete Payment",
            "not_find": "Can not find Payment with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the supplierPayment's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Payments Report",
            "payment_date": "Date",
            "user_display": "Created by"
        },
        "suppliers": {
            "add": "Add supplier",
            "edit": "Edit supplier",
            "delete": "Delete supplier",
            "not_find": "Can not find supplier with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the supplier's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Customers Report",
            "business_name": "Business name",
            "business_name_placeholder": "Enter the customer's business name",
            "phone": "Phone",
            "phone_name_placeholder": "Enter the customer's phone",
            "email": "Email",
            "email_name_placeholder": "Enter the customer's email",
            "rfc": "RFC",
            "rfc_name_placeholder": "Enter the customer's rfc",
            "address": "Address",
            "address_name_placeholder": "Enter the customer's address",
            "has_credit": "Has Credit?",
            "supplier_already_exists": "The supplier already exists"
        },
        "supplies": {
            "add": "Add supply",
            "edit": "Edit supply",
            "delete": "Delete supply",
            "not_find": "Can not find supply with this code.",
            "description_exists_error": "An supply already has this description, enter a different one.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the supply's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Supplies Report",
            "description": "Description",
            "description_name_placeholder": "Enter the supplies's description",
            "sku": "Sku",
            "sku_name_placeholder": "Enter the supplies's sku",
            "tax": "Tax",
            "tax_name_placeholder": "Enter the supplies's tax",
            "price_buy": "Price buy",
            "price_buy_name_placeholder": "Enter the supplies's price_buy",
            "unit_of_measurement": "Unit of Measurement",
            "unit_of_measurement_placeholder": "Enter the supplies's unit of measurement",
            "sat_code": "Sat code",
            "status_placeholder": "Select status"
        },
        "tax_receipts": {
            "add": "Add taxReceipt",
            "edit": "Edit taxReceipt",
            "delete": "Delete taxReceipt",
            "not_find": "Can not find taxReceipt with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the taxReceipt's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "TaxReceipts Report"
        },
        "users": {
            "add": "Add user",
            "edit": "Edit user",
            "delete": "Delete user",
            "not_find": "Can not find user with this code.",
            "actived_error": "User is already active",
            "inactived_error": "User is already inactive",
            "actived": "User has been activated",
            "inactived": "User has been inactivated",
            "active": "Active",
            "inactive": "Inactive",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the user's name",
            "email": "Email",
            "email_placeholder": "Enter the user's email",
            "password": "Password",
            "password_placeholder": "Enter the user's password",
            "confirm_password": "Confirm Password",
            "confirm_password_placeholder": "Enter the user's confirm password",
            "role": "Role",
            "role_placeholder": "Enter the user's role",
            "status": "Status",
            "leave_empty": "Leave empty to keep the current password",
            "created_at": "Created at",
            "report_title": "Users Report"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items.",
                "total": "The {attribute} may not be greater than {max}."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "lenght": "The {attribute} has many characters",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verify your Email Address",
            "check_email": "Check the inbox to finish the registration.",
            "check_email_label": "Check the email to finish the registration. We have sent you a registration link to the address:",
            "resend_email": "You have not received the registration link? Resend",
            "resend_succesfully": "Successfully resend",
            "reset_email": "Change email address"
        },
        "welcome": {
            "subject": "Welcome to Controlla",
            "line_1": "Welcome to controlla.",
            "action": "Start now"
        }
    },
    "es": {
        "auth": {
            "failed": "Estas credenciales no coinciden con nuestros registros.",
            "throttle": "Demasiados intentos de inicio de sesión. Por favor intente de nuevo en {seconds} segundos."
        },
        "branches": {
            "add": "Agregar sucursal",
            "edit": "Editar sucursal",
            "delete": "Eliminar sucursal",
            "not_find": "No se puede encontrar un sucursal con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre de la sucursal",
            "business_name": "Razón social",
            "business_name_placeholder": "Ingresa la Razón social de la sucursal",
            "address": "Dirección",
            "address_placeholder": "Ingresa la dirección de la sucursal",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Branches"
        },
        "contacts": {
            "add": "Agregar Contacto",
            "edit": "Editar Contacto",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un Contacto con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del Contacto",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Contactos",
            "position": "Puesto",
            "position_placeholder": "Ingresa el puesto del Contacto",
            "customer_id": "Cliente",
            "customer_supplier": "Customer/Supplier",
            "phone": "Teléfono",
            "phone_placeholder": "Ingresa el teléfono del Contacto",
            "customer_placeholder": "Ingresa el Cliente del Contacto",
            "email": "Email",
            "email_placeholder": "Ingresa el correo del Contacto"
        },
        "customer_addresses": {
            "add": "Agregar Dirección",
            "edit": "Editar Dirección",
            "delete": "Eliminar Dirección",
            "not_find": "No se puede encontrar una Dirección con este código.",
            "id": "Id",
            "address_name": "Nombre",
            "address_name_placeholder": "Ingresa el Nombre de la Dirección",
            "street_name": "Calle",
            "street_name_placeholder": "Ingresa el Calle de la Dirección",
            "street_number": "Numero",
            "street_number_placeholder": "Ingresa el Numero de la Dirección",
            "city": "Ciudad",
            "city_placeholder": "Ingresa el Ciudad de la Dirección",
            "state": "Estado",
            "state_placeholder": "Ingresa el Estado de la Dirección",
            "country": "Pais",
            "country_placeholder": "Ingresa el Pais de la Dirección",
            "zip_code": "Codigo Postal",
            "zip_code_placeholder": "Ingresa el Codigo Postal de la Dirección",
            "customer_display": "Cliente",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de CustomerAddresses"
        },
        "customer_purchase_order_details": {
            "add": "Agregar detalle de orden de compra",
            "edit": "Editar detalle de orden de compra",
            "delete": "Eliminar detalle de orden de compra",
            "not_find": "No se puede encontrar un detalle de orden de compra con este código.",
            "on_time": "A tiempo",
            "mistime": "Entrega a Destiempo",
            "cancelled": "Cancelado",
            "delivered": "Entregado",
            "id": "#",
            "purchase_order_display": "Orden de Compra",
            "purchase_order_id": "Id Orden de Compra",
            "name": "Descripción del Producto",
            "name_placeholder": "Ingresa el nombre del detalle de orden de compra",
            "quantity": "Cantidad",
            "quantity_placeholder": "Ingresa la cantidad",
            "unit_price": "Precio Unitario",
            "unit_price_placeholder": "Ingresa el precio unitario",
            "amount": "Total",
            "delivery_status": "Estatus",
            "production_status_display": "Estatus de Producción",
            "production_status_placeholder": "Seleccione el Estatus de Producción",
            "production_area_display": "Area de Producción",
            "production_area_placeholder": "Seleccione el Area de Producción",
            "currency_display": "Moneda",
            "customer_display": "Cliente",
            "folio": "Folio",
            "purchase_order_folio": "Folio",
            "requisitor": "Requisitor",
            "delivery_time": "Tiempo de Entrega",
            "delivery_time_placeholder": "Ingrese el Tiempo de entrega",
            "delivery_date": "Fecha de Entrega",
            "delivery_date_placeholder": "Seleccione la fecha de Entrega",
            "destination": "Destino",
            "destination_placeholder": "Ingrese el Destino",
            "invoiced_amount": "Cantidad Facturada",
            "amount_to_invoice": "Cantidad a Facturar",
            "total_import": "Total",
            "subtotal": "Subtotal",
            "tax": "Tax",
            "total_with_tax": "Importe Total",
            "notes": "Notas",
            "number": "No. de Orden",
            "created_at": "Creado en",
            "report_title": "Reporte de Detalle de ordenes de Compra de Cliente",
            "without_process_date": "Fecha sin proceso",
            "in_progress_date": "Fecha en proceso",
            "stoped_date": "Fecha detenido",
            "forged_date": "Fecha herreria",
            "fold_die_cut_date": "Fecha dobles y troquelado",
            "enabled_date": "Fecha habilitado",
            "paint_date": "Fecha pintura",
            "finished_date": "Fecha terminado",
            "customer": "Cliente",
            "customer_name": "Cliente",
            "production_area": "Area de producción",
            "production_status": "Estatus de Producción",
            "currency": "Moneda",
            "status": "Estatus",
            "product": "Producto",
            "payments": "Pagos"
        },
        "customer_purchase_orders": {
            "add": "Agregar orden de compra de cliente",
            "edit": "Editar orden de compra de cliente",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un orden de compra de cliente con este código.",
            "sended": "Enviada",
            "completed": "Completa",
            "pending": "Pendiente",
            "cancelled": "Cancelada",
            "partially_stocked": "Parcialmente Abastecida",
            "authorized": "Autorizada",
            "id": "Id",
            "number": "No. de Orden",
            "number_placeholder": "Ingrese el numero de orden de compra",
            "customer_display": "Cliente",
            "project_display": "Proyecto",
            "folio": "Folio",
            "folio_placeholder": "Ingrese el Folio",
            "currency_display": "Moneda",
            "exchange_rate": "Tipo de Cambio",
            "exchange_rate_placeholder": "Ingrese el tipo de cambio",
            "requisitor": "Requisitor",
            "requisitor_placeholder": "Ingrese el requisitor",
            "tax_type": "Tax Type",
            "tax_amount": "Tax Amount",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Ordenes de Compra de Clientes",
            "quantity": "Cantidad",
            "production_status_display": "Estatus de produccion",
            "production_area_display": "Area de produccion",
            "delivery_status": "Tiempo",
            "destination": "Destino",
            "unit_price": "Costo",
            "amount": "Monto",
            "name": "Descripción",
            "note": "Nota",
            "delivery_date": "Fecha de entrega",
            "invoiced_amount": "Cantidad Facturada",
            "amount_to_invoice": "Cantidad por Facturar",
            "payment_deadline": "Plazo de Pago",
            "payment_deadline_placeholder": "Seleccione el Plazo de Pago"
        },
        "customers": {
            "add": "Agregar cliente",
            "edit": "Editar cliente",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un cliente con este código.",
            "quotation_with_customer": "No se puede eliminar el Cliente, existen cotizaciones con este Cliente",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del cliente",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de clientes",
            "business_name": "Razón social",
            "business_name_placeholder": "Ingresa la Razón social del cliente",
            "phone": "Teléfono",
            "phone_placeholder": "Ingresa el teléfono del cliente",
            "email": "Correo Electrónico",
            "email_placeholder": "Ingresa el correo del cliente",
            "rfc": "RFC",
            "rfc_placeholder": "Ingresa el rfc del cliente",
            "address": "Dirección",
            "address_placeholder": "Ingresa la dirección del cliente",
            "without_invoices": "El cliente no tiene facturas con "
        },
        "errors": {
            "fatal_error": "Se produjo un error fatal, póngase en contacto con nosotros.",
            "generic_error": "Ha ocurrido un error. Por favor intente de nuevo.",
            "unauthorized": "No autorizado.",
            "connection_error": "Error de conexión",
            "action_unauthorized": "No estas autorizado para realizar esta acción"
        },
        "feedback": {
            "rate": "¿Como te parece este sistema?",
            "comment": "¿Cuéntanos cómo ha sido tu experiencia?",
            "contact_me": "Controlla puede comunicarse conmigo en relación con mis comentarios."
        },
        "front": {
            "values": "Valores",
            "added_successfully": "Ha sido agregado con éxito.",
            "updated_successfully": "Ha sido actualizado con éxito.",
            "deleted_successfully": "Ha sido eliminado con éxito.",
            "imported_successfully": "Ha sido importado con éxito.",
            "delete_modal": "Eliminar",
            "delete_confirmation": "¿Seguro que quieres eliminar la {model} {attribute}?",
            "delete_confirmation2": "¿Seguro que quieres eliminar el {model} {attribute}?",
            "action_confirmation": "¿Seguro que deseas {action} esta {model}?",
            "action_confirmation2": "¿Seguro que deseas {action} este {model}?",
            "import_modal": "Importar {model} desde un archivo CSV o Excel"
        },
        "invoiced_products": {
            "add": "Agregar invoicedProduct",
            "edit": "Editar invoicedProduct",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un invoicedProduct con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del invoicedProduct",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de InvoicedProducts"
        },
        "invoices": {
            "add": "Agregar factura",
            "edit": "Editar factura",
            "delete": "Eliminar factura",
            "not_find": "No se puede encontrar un factura con este código.",
            "paid": "Pagada",
            "partially_paid": "Pagada Parcial",
            "pending": "Pendiente",
            "1": "Si",
            "0": "No",
            "detail": "Detalle de factura",
            "id": "Pre Factura",
            "number": "Factura",
            "number_placeholder": "Ingrese el numero de factura",
            "purchase_order": "Orden de compra",
            "purchase_order_display": "Orden de Compra",
            "date": "Fecha de facturación",
            "discount": "Descuento",
            "discount_placeholder": "Ingrese el Descuento",
            "amount": "Total",
            "currency": "Moneda",
            "status": "Estatus",
            "total": "Total",
            "subtotal_amount": "Subtotal",
            "compaq": "Folio Compaq",
            "compaq_placeholder": "Ingrese el Folio de compaq",
            "tax_receipt_display": "CFDI",
            "cfdi_placeholder": "Seleccione el CFDI",
            "late_payment": "Atraso",
            "portal_date": "Fecha Portal",
            "signature": "Factura Firmada",
            "comments": "Observaciones",
            "payment_deadline": "Plazo de Pago",
            "customer_display": "Cliente",
            "created_at": "Creado en",
            "user_display": "Creado por",
            "report_title": "Reporte de Factura",
            "type": "Tipo",
            "tax_amount": "Iva",
            "subtotal": "Subtotal",
            "currency_payment": "Moneda",
            "project": "Proyecto"
        },
        "login": {
            "email": "Correo electrónico",
            "password": "Contraseña",
            "keep_connected": "Recordarme",
            "forgot_password": "Restablecer",
            "login": "Iniciar sesión",
            "logout": "Cerrar sesión",
            "reset_password": "Restablecer la contraseña",
            "send_reset_link": "Enviar el enlace de reinicio",
            "password_confirmation": "Confirmación de contraseña",
            "still_having_trouble": "¿Sigues teniendo problemas para iniciar sesión?",
            "havent_account": "No tienes una cuenta?",
            "back_login": "Volver a Inicio de sesión",
            "register": "Crear cuenta",
            "welcome": "Bienvenido",
            "description": "Descripción",
            "user": "Usuario"
        },
        "notifications": {
            "empty_title": "No hay notificaciones en este momento",
            "empty_msg": "Cuando tu equipo empiece a hacer cosas, mostraremos las notificaciones aquí.",
            "add_new_user": "Usuario Nuevo!",
            "add_new_user_message": "agrego un nuevo usuario"
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "passwords": {
            "password": "Las contraseñas deben tener al menos seis caracteres y coincidir con la confirmación.",
            "reset": "¡Tu contraseña ha sido restablecida!",
            "sent": "Hemos enviado por correo electrónico el enlace para restablecer su contraseña!",
            "token": "Este token de restablecimiento de contraseña no es válido.",
            "user": "No podemos encontrar un usuario con esa dirección de correo electrónico.",
            "cant_login": "¿No puedes iniciar sesión?",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "payments": {
            "add": "Agregar pago",
            "edit": "Editar pago",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un pago con este código.",
            "transfer": "Transferencia",
            "check": "Cheque",
            "other": "Otro",
            "cash": "Efectivo",
            "1": "Banorte",
            "2": "Banregio",
            "3": "Intercam",
            "4": "Monex",
            "id": "Id",
            "invoice_display": "Factura",
            "invoice_placeholder": "Ingrese el numero de factura",
            "amount": "Cantidad",
            "amount_placeholder": "Ingrese la cantidad",
            "total": "Total",
            "total_placeholder": "Ingrese el Total",
            "subtotal": "Subtotal",
            "tax_amount": "Iva",
            "date": "Fecha de pago",
            "date_placeholder": "Seleccione la fecha de pago",
            "type": "Tipo de Pago",
            "type_placeholder": "Seleccione el tipo de pago",
            "receipt": "Recibo de Pago",
            "receipt_placeholder": "Ingrese el Recibo del Pago",
            "bank": "Banco",
            "bank_placeholder": "Seleccione el Banco",
            "created_at": "Creado en",
            "report_title": "Reporte de Pagos",
            "user_display": "Creado Por"
        },
        "production_areas": {
            "add": "Agregar Área de Producción",
            "edit": "Editar Área de Producción",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un Área de Producción con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del Área de Producción",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Áreas de Producción"
        },
        "production_statuses": {
            "add": "Agregar Estatus de Producción",
            "edit": "Editar Estatus de Producción",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un Estatus de Producción con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del Estatus de Producción",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Estatus de producción"
        },
        "products": {
            "add": "Agregar productos",
            "edit": "Editar productos",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un productos con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del producto",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Productos",
            "sku": "Sku",
            "sku_placeholder": "Ingresa el sku",
            "category": "Categoria",
            "category_id": "Categoria",
            "category_placeholder": "Selecciona la categoria",
            "unit_price": "Precio Unitario",
            "unit_price_placeholder": "Ingresa el Precio Unitario"
        },
        "projects": {
            "add": "Agregar proyecto",
            "edit": "Editar proyecto",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un proyecto con este código.",
            "add_purchase_order": "Agregar Orden de Compra",
            "in_progress": "En Progreso",
            "finished": "Terminado",
            "id": "Folio",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del Proyecto",
            "customer_display": "Cliente",
            "customer_placeholder": "Seleccione el Cliente",
            "total_amount": "Monto Total",
            "total_amount_placeholder": "Ingrese el monto total",
            "tax": "Impuesto",
            "tax_placeholder": "Ingrese el impuesto",
            "delivery_address": "Dirección de entrega",
            "delivery_address_placeholder": "Ingrese la dirección de entrega",
            "authorization_date": "Fecha de Autorización",
            "authorization_date_placeholder": "Seleccione la fecha de autorización",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Proyectos",
            "invoices_usd": "Facturas de ingreso USD",
            "invoices_mxn": "Facturas de ingreso MXN",
            "billed_balance": "Saldo facturado",
            "balance_paid": "Saldo pagado",
            "Balance_to_be_billed": "Saldo por facturar",
            "subtotal_amount": "Monto sin Iva",
            "total_without_iva": "Total del proyecto sin IVA",
            "total_amount_invoice_without_iva": "Monto Facturado sin IVA",
            "total_amount_paid_without_iva": "Monto Pagado sin IVA",
            "pending_amount_without_iva": "Monto pentiende de facturar sin IVA",
            "total": "Total del proyecto",
            "total_amount_invoice": "Monto Facturado",
            "total_amount_paid": "Monto Pagado",
            "pending_amount": "Monto pentiende de facturar",
            "show_iva": "Mostrar desglose"
        },
        "purchase_orders": {
            "add": "Agregar orden de compra",
            "edit": "Editar orden de compra",
            "delete": "Eliminar orden de compra",
            "not_find": "No se puede encontrar una orden de compra con este código.",
            "status": "Estatus",
            "send": "Enviada",
            "authorize": "Autorizada",
            "send_order": "Enviar Orden",
            "authorize_order": "Autorizar Orden",
            "cancel_order": "Cancelar Orden",
            "sended": "Enviada",
            "completed": "Completada",
            "pending": "Pendiente",
            "cancelled": "Cancelada",
            "cancel": "Cancelada",
            "partially_stocked": "Parcialmente abastecido",
            "authorized": "Autorizada",
            "cancel_error": "La orden de compra ya esta cancelada",
            "sended_error": "La orden de compra ya se envió",
            "created_at": "Creado en",
            "report_title": "Reporte de Ordenes de compra",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Ingrese el Folio de la requisición",
            "project_display": "Proyecto",
            "project_placeholder": "Ingrese el nombre del proyecto",
            "supplier_display": "Proveedor",
            "supplier_placeholder": "Ingrese el nombre del proveedor",
            "user_display": "Creado por",
            "email": "Correo Electrónico",
            "email_placeholder": "Ingrese el Correo Electrónico",
            "shipping_address": "Dirección de envio",
            "shipping_address_placeholder": "Ingrese la dirección de envio",
            "delivery_time": "Tiempo de entrega (Días)",
            "delivery_time_placeholder": "Ingrese el tiempo de entrega en días",
            "deadline": "Fecha limite",
            "deadline_placeholder": "Ingrese la Fecha limite en días",
            "freight": "Flete",
            "freight_placeholder": "Seleccione si utiliza flete",
            "notes": "Notas",
            "notes_placeholder": "Ingrese notras (Opcional)",
            "summary": "Resúmen de Orden",
            "download_all_pdf": "Descargar todo",
            "download_pdf": "Descargar PDF",
            "information": "Revisa la información detallas antes de descargar tu archivo.",
            "exit": "Salir de Orden de compra",
            "supply_amount": "Cantidad",
            "supply_unit": "Ud",
            "supply": "Producto",
            "supply_order_quantity": "Ordenada",
            "remaining": "Restante",
            "for_recieving": "Por Recibir",
            "received": "Recibido",
            "user": "Usuario",
            "supply_pending_quantity": "Cantidad",
            "to_receive": "Recibir orden",
            "number": "Numero de Factura",
            "number_placeholder": "Ingresa el Numero de Factura",
            "placeholder_justify": "Justifica el motivo para cerrar esta requisición",
            "justify": "Justificación",
            "supply_description": "Producto",
            "currency": "Moneda",
            "tax_type": "Tax Type",
            "tax_amount": "Tax Amount",
            "product": "Producto",
            "description": "Descripción",
            "unit_of_measurement": "Unidad",
            "quantity": "Cantidad",
            "projects": "Projectos",
            "suppliers": "Proveedores"
        },
        "quotations": {
            "add": "Agregar cotización",
            "edit": "Editar cotización",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar una cotización con este código.",
            "quotation": "Cotización",
            "authorized_error": "Esta Cotización ya esta Autorizada",
            "authorize": "Autorizada",
            "authorize_title": "Autorizar cotización",
            "id": "Id",
            "name": "Nombre",
            "project": "Proyecto",
            "name_placeholder": "Ingresa el nombre de la Cotización",
            "customer": "Cliente",
            "customer_placeholder": "Ingresa el cliente de la Cotización",
            "contact": "Contacto",
            "contact_placeholder": "Ingresa el contacto de la Cotización",
            "currency": "Moneda",
            "currency_placeholder": "Ingresa el tipo de Moneda de la Cotización",
            "address": "Dirección de entrega",
            "address_placeholder": "Ingresa la Dirección de entrega de la Cotización",
            "payment_conditions": " Condición de pago",
            "payment_conditions_placeholder": "Ingresa la Condición de pago de la Cotización",
            "tax_type": "Iva",
            "tax_type_placeholder": "Ingresa el Iva de la Cotización",
            "tax_amount": "Iva",
            "product_id": "Producto",
            "product_id_placeholder": "Ingresa el Producto de la Cotización",
            "product": "Producto",
            "product_placeholder": "Seleccióna el Producto de la Cotización",
            "price_neto": "Precio de venta",
            "price_neto_placeholder": "Ingresa el precio",
            "quantity": "Cantidad",
            "quantity_placeholder": "Ingresa la Cantidad de la Cotización",
            "amount": "Total",
            "amount_placeholder": "Ingresa el Total de la Cotización",
            "status": "Estatus",
            "created_by": "Creado por",
            "folio": "Folio",
            "authorized": "Autorizada",
            "cancelled": "Cancelada",
            "pending": "Pendiente",
            "action": " ",
            "totals": "Totales",
            "total": "Total",
            "subtotal": "Subtotal",
            "total_amount": "Precio de venta",
            "quotation_total": "Precio de venta",
            "folio_placeholder": "Ingresa el Folio de la Cotización",
            "delivery_date": "Fecha de Entrega",
            "destination": "Destino",
            "created_at": "Creado en",
            "report_title": "Quotations Report",
            "previous": "Anterior",
            "next": "Siguiente",
            "save": "Guardar",
            "step_one": "Paso 1",
            "master_data": "Datos Maestros",
            "master_data_description": "Completa la siguiente información acerca del proyecto que desea cotizar.",
            "step_two": "Paso 2",
            "details_data": "Datos de detalle",
            "step_three": "Paso 3",
            "extra_information": "Información Extra",
            "attached_file": "Archivo adjunto",
            "notes": "Notas",
            "write_here": "Esribe aqui",
            "description_attached": "Arrastra o importa archivos de Excel",
            "summary": "Resúmen",
            "step_four": "Paso 4",
            "description_four": "Revisa la información detallas antes de descargar tu archivo.",
            "download_pdf": "Descargar PDF",
            "progress": "En Progreso",
            "complete": "Completado",
            "clean_table": "Limpiar tabla",
            "add_requisite": "Crear nuevo requisitor",
            "requisite": "Requisitor",
            "requisiteres": "Requisitores",
            "requisite_placeholder": "Ingresa el Requisitor de la Cotización",
            "add_branche": "Crear nueva Sucursal",
            "branche": "Sucursal",
            "branches": "Sucursales",
            "branche_placeholder": "Ingresa la Sucursal de la Cotización",
            "exchange_rate": "Tipo de Cambio",
            "exchange_rate_placeholder": "Ingresa el tipo de cambio",
            "clone": "Duplicar",
            "unit_price": "Precio unitario",
            "download_template": "Descargar plantilla",
            "total_freight": "Flete",
            "add_contact": "Agregar contacto",
            "additional_conditions": "Condiciones Adicionales",
            "description": "Descripcion",
            "unit": "Unidad"
        },
        "reception_details": {
            "add": "Agregar receptionDetail",
            "edit": "Editar receptionDetail",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un receptionDetail con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del receptionDetail",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de ReceptionDetails"
        },
        "receptions": {
            "add": "Agregar recepción",
            "edit": "Editar recepción",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un recepción con este código.",
            "receptioned": "Recepcionado",
            "cancelled": "Cancelado",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre de la recepción",
            "folio": "Folio",
            "purchase_order_display": "Orden de Compra",
            "product_amount": "Cantidad",
            "reception_date": "Fecha de Recepción",
            "user_display": "Creado por",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Receptions",
            "invoice_number": "Numero de Recepción"
        },
        "register": {
            "title": "Regístrate para obtener tu cuenta",
            "email": "Correo electrónico",
            "name": "Nombre de usuario",
            "password": "Contraseña",
            "register": "Crear cuenta",
            "message": "Al registrarte, confirmas que has leído y aceptado nuestros <a href=\"/login\" class=\"content-vertical text-secondary\"> Términos de uso</a> y nuestra <a href=\"/login\"> Política de privacidad</a>.",
            "back_login": "¿Ya tienes una cuenta de Controlla? Iniciar sesión",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "requisition_details": {
            "add": "Agregar detalle",
            "edit": "Editar detalle",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un detalle con este código.",
            "supply_id": "Identificador de Suministro",
            "supply_display": "Suministro",
            "supply_placeholder": "Selecciona suministro",
            "supply_amount_display": "Monto suministro",
            "supply_amount_placeholder": "Inserta monto suministro",
            "supply_order_quantity_display": "Cantidad orden de suministro",
            "supply_order_quantity_placeholder": "Inserta cantidad orden de suministro",
            "supply_pending_quantity_display": "Cantidad pendiente suministro",
            "supply_pending_quantity_placeholder": "Inserta cantidad pendiente suministro",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del detalle",
            "supply_description": "Descripción",
            "supply_unit": "Unidad de Medida",
            "supply_amount": "Cantidad",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de RequisitionDetails"
        },
        "requisitioners": {
            "add": "Agregar Requisitor",
            "edit": "Editar Requisitor",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un Requisitor con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del Requisitor",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Requisitores"
        },
        "requisitions": {
            "add": "Agregar requisición",
            "edit": "Editar requisición",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un requisición con este código.",
            "id": "#",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre de la requisición",
            "status": "Estatus",
            "pending": "Pendiente",
            "accepted": "Aceptada",
            "closed": "Cerrada",
            "created_at": "Creado en",
            "report_title": "Reporte de Requisiciones",
            "folio": "Folio",
            "folio_placeholder": "Ingrese el Folio de la requisición",
            "project_display": "Proyecto",
            "project_placeholder": "Ingrese el nombre del proyecto",
            "product_amount": "No. de productos",
            "product_amount_placeholder": "Ingrese la cantidad el numero de productos",
            "user_display": "Creado por"
        },
        "requisitions_mailboxes": {
            "add": "Agregar requisicion",
            "edit": "Editar requisicion",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar una requisicion con este código.",
            "id": "#",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del requisicion",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de RequisitionsMailboxes",
            "requisitions_mailboxes": "Buzón de Requisiciones",
            "folio": "Folio",
            "project": "Proyecto",
            "product_amount": "No. Productos",
            "products": "Productos",
            "product": "Producto",
            "supply_amount": "Cantidad",
            "supply_unit": "Ud",
            "supply": "Producto",
            "supply_order_quantity": "Ordenada",
            "user": "Usuario",
            "supply_pending_quantity": "Cantidad",
            "filter": "Busca por producto o SKU:",
            "end_session": "Finalizar sesión",
            "end_order": "Finalizar orden",
            "create_order": "Crear orden",
            "action": " ",
            "continue_editing": "Continuar Editando",
            "edit_later": "Editar Luego",
            "almacen": "Mover a almacen",
            "unit_price": "Precio Unitario",
            "total": "Total"
        },
        "reset": {
            "subject": "Restablece tu contraseña de Controlla",
            "line_1": "Recibió este correo electrónico porque recibimos una solicitud de restablecimiento de contraseña para su cuenta.",
            "action": "Restablecer contraseña",
            "line_2": "Este enlace de restablecimiento de contraseña caducará en {count} minutos.",
            "line_3": "Si no solicitó un restablecimiento de contraseña, no se requiere ninguna otra acción."
        },
        "strings": {
            "dashboard": "Dashboard",
            "overview": "Inicio",
            "users": "Usuarios",
            "report": "Reporte",
            "user": "Usuario",
            "branch": "Sucursal",
            "branches": "Sucursales",
            "customer": "Cliente",
            "customers": "Clientes",
            "customer_address": "Dirección",
            "customer_addresses": "Direcciónes",
            "customer_purchase_order": "Orden de Compra de Cliente",
            "customer_purchase_orders": "Ordenes de Compra de Cliente",
            "customer_oc": "O.C. Cliente",
            "invoice_detail": "Detalle de Factura",
            "supplier_oc": "O.C. Proveedores",
            "customer_purchase_order_detail": "Detalle de Orden de Compra de Cliente",
            "customer_purchase_order_details": "Detalles de Orden de Compra de Cliente",
            "quotation": "Cotización",
            "quotations": "Cotizaciones",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "production_area": "Área de Producción",
            "production_areas": "Áreas de Producción",
            "purchase_order": "Orden de Compra",
            "purchase_orders": "Ordenes de Compra",
            "oc_number": "# O.C.",
            "sale": "Venta",
            "sales": "Ventas",
            "supply": "Insumo",
            "supplies": "Insumos",
            "supplier": "Proveedor",
            "supplier_invoice": "Factura",
            "suppliers": "Proveedores",
            "payment": "Pago",
            "payments": "Pagos",
            "production_status": "Estatus de Producción",
            "production_statuses": "Estatus de Producción",
            "product": "Producto",
            "products": "Productos",
            "mining_group": "Grupo Minero",
            "mining_groups": "Grupos Mineros",
            "project": "Proyecto",
            "projects": "Proyectos",
            "requisitioners": "Requisitores",
            "requisitioner": "Requisitor",
            "requisition": "Requisición",
            "requisitions": "Requisiciones",
            "requisition_detail": "Detalle de Requisición",
            "requisition_details": "Detalles de Requisición",
            "id": "id",
            "amount": "Total",
            "description": "Un resumen de sus {attribute}",
            "search": "Buscar {attribute} por{columns} ó {column}",
            "filters": "Filtros",
            "clear": "Limpiar",
            "apply": "Aplicar",
            "select_date": "Selecciona una fecha",
            "multiple": "Selección multiple",
            "display_list": "Ver en lista",
            "display_grid": "Ver en grid (deshabilitado)",
            "print": "Imprimir",
            "delete": "Eliminar",
            "add": "Agregar",
            "addDetail": "Agregar Detalle",
            "edit": "Editar",
            "save": "Guardar",
            "accept": "Aceptar",
            "cancel": "Cancelar",
            "view": "Ver",
            "import": "Importar",
            "import_excel": "Importar Excel",
            "download": "Descargar",
            "authorized": "Autorizar",
            "export": "Exportar",
            "registered_on": "Registrado desde",
            "order_by": "Ordenado por",
            "options": "Más opciones",
            "notifications": "Notificaciones",
            "messages": "Mensajes",
            "no_notifications": "No tienes notificaciones",
            "no_messages": "No tienes mensajes",
            "see_all": "Marcar todo como leído",
            "exit": "Salir",
            "feedback": "Enviar Comentarios",
            "give_feedback": "Dar opinión",
            "shortcuts": "Atajos de teclado",
            "close_modal": "Cerrar modal",
            "create": "Crear registro",
            "view_selected": "Ver seleccionado",
            "edit_selected": "Editar seleccionado",
            "view_notifications": "Ver notificaciones",
            "find": "Buscar un registro",
            "register": "Registro",
            "inition": "Inicio",
            "commercial": "Comercial",
            "purchases": "Compras",
            "catalogs": "Catalogos",
            "cancelled": "Cancelado",
            "sold": "Vendido",
            "invoiced": "Facturado",
            "paid": "Pagado",
            "pending": "Pendiente",
            "approved": "Aprobado",
            "received": "Recibido",
            "send": "Enviado",
            "status": "Estatus",
            "action_sold": "Pagar",
            "action_invoiced": "Facturar",
            "action_paid": "Pagar",
            "action_approved": "Aprobar",
            "action_received": "Recibir",
            "action_send": "Enviar",
            "action_active": "Activar",
            "action_inactive": "Inactivar",
            "contacts": "Contactos",
            "contact": "Contact",
            "add_contacts": "Agregar contacto",
            "requisitions_mailboxes": "Buzón de Requisiciones",
            "reception": "Recepción",
            "receptions": "Recepciónes",
            "warehouse_receptions": "Recepción en almacén",
            "warehouse_receptions_description": "Ingresa el número de Folio del proveedor para buscar la orden deseada",
            "invoice": "Factura",
            "invoices": "Facturas",
            "supplier_invoices": "Facturas a Proveedores",
            "customer_invoices": "Facturas de Clientes",
            "add_invoice": "Agregar Factura",
            "total_invoice": "Total a Facturar",
            "total_payment": "Total a Pagar",
            "total_remaining": "Total Restante",
            "invoice_details": "Detalle de factura",
            "manufacturing": "Fabricación",
            "income": "Ingresos",
            "expenses": "Egresos",
            "difference": "Diferencia",
            "quoted": "Cotizado",
            "authorized_quotes": "Cotizaciones Autorizadas",
            "open_quotes": "Cotizaciones Abiertas",
            "quoted_vs_authorized": "Cotizado vs Autorizado",
            "search_by_date": "Buscar por fecha",
            "date": "Fecha",
            "total_purchase_orders": "Total de ordenes de compra",
            "total": "Total",
            "total_hired": "Total contratado",
            "currency": "Moneda",
            "balance": "Balance",
            "search_by_customer": "Buscar por cliente",
            "payments_vs_invoices": "Pagos vs Facturas",
            "payed": "Pagado",
            "nothing_to_view": "¡No hay nada que mostrar aqui!",
            "without_customers": "No existen clientes registrados"
        },
        "supplier_invoices": {
            "add": "Agregar factura",
            "edit": "Editar factura",
            "delete": "Eliminar factura",
            "not_find": "No se puede encontrar un factura con este código.",
            "paid": "Pagada",
            "partial": "Pagada Parcial",
            "pending": "Pendiente",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del supplierInvoice",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Facturas",
            "invoice_number": "Numero de Factura",
            "invoice_number_placeholder": "Ingresa el Numero de Factura",
            "invoice_date": "Fecha",
            "total_invoice": "Total a Facurar",
            "amount_placeholder": "Ingresa el Monto",
            "amount": "Monto",
            "total": "Monto Bruto",
            "subtotal": "Subtotal",
            "tax_amount": "Iva",
            "supplier": "Proveedor",
            "cash": "Cash",
            "card": "Card",
            "transfers": "Transfers",
            "payment_type_placeholder": "Selecciona el tipo de pago",
            "payment_type": "Tipo de pago",
            "payment_date": "Fecha",
            "user_display": "Creado por",
            "currency": "Moneda"
        },
        "supplier_payments": {
            "add": "Agregar Pago",
            "edit": "Editar Pago",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un Pago con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del supplierPayment",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Pagos",
            "payment_date": "Fecha"
        },
        "suppliers": {
            "add": "Agregar proveedor",
            "edit": "Editar proveedor",
            "delete": "Eliminar proveedor",
            "not_find": "No se puede encontrar un proveedor con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del proveedor",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Suppliers",
            "business_name": "Razón social",
            "business_name_placeholder": "Ingresa la Razón social del proveedor",
            "phone": "Teléfono",
            "phone_placeholder": "Ingresa el teléfono del proveedor",
            "email": "Correo Electrónico",
            "email_placeholder": "Ingresa el correo del proveedor",
            "rfc": "RFC",
            "rfc_placeholder": "Ingresa el rfc del proveedor",
            "address": "Dirección",
            "address_placeholder": "Ingresa la dirección del proveedor",
            "has_credit": "¿Cuenta con credito?",
            "supplier_already_exists": "El proveedor ya existe"
        },
        "supplies": {
            "add": "Agregar insumo",
            "edit": "Editar insumo",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un insumo con este código.",
            "description_exists_error": "Un insumo ya tiene esta descripción, ingrese una diferente.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del insumo",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Supplies",
            "description": "Descripción",
            "description_placeholder": "Ingresa la descripción del insumo",
            "sku": "Sku",
            "sku_placeholder": "Ingresa el sku del insumo",
            "tax": "Impuestos",
            "tax_placeholder": "Ingresa el impuesto del insumo",
            "price_buy": "Precio de compra",
            "price_buy_placeholder": "Ingresa el precio de compra del insumo",
            "unit_of_measurement": "Unidad de Medida",
            "unit_of_measurement_placeholder": "Ingrese la Unidad de Medida del insumo",
            "sat_code": "Clave de Sat",
            "sat_code_placeholder": "Ingresa el codigo de sat del insumo",
            "status_placeholder": "Selecciona el status"
        },
        "tax_receipts": {
            "add": "Agregar taxReceipt",
            "edit": "Editar taxReceipt",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un taxReceipt con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del taxReceipt",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de TaxReceipts"
        },
        "users": {
            "add": "Agregar usuario",
            "edit": "Editar usuario",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un usuario con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El usuario se ha activado",
            "inactived": "El usuario se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del usuario",
            "email": "Correo",
            "email_placeholder": "Ingresa el correo electrónico del usuario",
            "password": "Contraseña",
            "password_placeholder": "Ingresa la contraseña del usuario",
            "confirm_password": "Confirma Contraseña",
            "confirm_password_placeholder": "Confirma la contraseña del usuario",
            "role": "Rol",
            "role_placeholder": "Ingresa el rol del usuario",
            "status": "Estatus",
            "leave_empty": "Dejar vacío para mantener la contraseña actual.",
            "created_at": "Creado en",
            "report_title": "Reporte de Usuarios"
        },
        "validation": {
            "accepted": "El campo {attribute} debe ser aceptado.",
            "active_url": "El campo {attribute} no es una URL válida.",
            "after": "El campo {attribute} debe ser una fecha después a {date}.",
            "after_or_equal": "El campo {attribute} debe ser una fecha posterior o igual a {date}.",
            "alpha": "El campo {attribute} solo puede contener letras.",
            "alpha_dash": "El campo {attribute} solo puede contener letras, números, guiones y guiones bajos.",
            "alpha_num": "El campo {attribute} solo puede contener letras y números.",
            "array": "El campo {attribute} debe ser una matriz.",
            "before": "El campo {attribute} debe ser una fecha antes de {date}.",
            "before_or_equal": "El campo {attribute} debe ser una fecha antes o igual a {date}.",
            "between": {
                "numeric": "El {attribute} debe estar entre {min} y {max}.",
                "file": "El {attribute} debe estar entre {min} y {max} kilobytes.",
                "string": "El {attribute} debe estar entre {min} y {max} caracteres.",
                "array": "El {attribute} debe estar entre {min} y {max} artículos."
            },
            "boolean": "El campo {attribute} debe ser verdadero o falso.",
            "confirmed": "El {attribute} la confirmación no coincide.",
            "date": "La {attribute} no es una fecha valida.",
            "date_format": "La {attribute} no coincide con el formato {format}.",
            "different": "El {attribute} y {other} deben ser diferentes.",
            "digits": "El {attribute} deben ser {digits} dígitos.",
            "digits_between": "El {attribute} debe estar entre {min} y {max} dígitos.",
            "dimensions": "El {attribute} tiene dimensiones de imagen inválidas.",
            "distinct": "El {attribute} campo tiene un valor duplicado.",
            "email": "El campo {attribute} debe ser una dirección de correo electrónico válida.",
            "exists": "El seleccionado {attribute} no es válido.",
            "file": "El {attribute} debe ser un archivo.",
            "filled": "El {attribute} campo debe tener un valor.",
            "gt": {
                "numeric": "El {attribute} debe ser mayor que {value}.",
                "file": "El {attribute} debe ser mayor que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor que {value} caracteres.",
                "array": "El {attribute} debe tener más que {value} artículos."
            },
            "gte": {
                "numeric": "El {attribute} debe ser mayor o igual que {value}.",
                "file": "El {attribute} debe ser mayor o igual que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor o igual que {value} caracteres.",
                "array": "El {attribute} debe tener {value} artículos o más."
            },
            "image": "La {attribute} debe ser una imagen.",
            "in": "El seleccionado {attribute} no es válido.",
            "in_array": "El {attribute} campo no existe en {other}.",
            "integer": "El {attribute} debe ser un entero.",
            "ip": "La {attribute} debe ser una dirección IP válida.",
            "ipv4": "La {attribute} debe ser una dirección IPv4 válida.",
            "ipv6": "La {attribute} debe ser una dirección IPv6 válida.",
            "json": "La {attribute} debe ser una cadena JSON válida.",
            "lt": {
                "numeric": "El {attribute} debe ser menor que {value}.",
                "file": "El {attribute} debe ser menor que {value} kilobytes.",
                "string": "El {attribute} debe ser menor que {value} caracteres.",
                "array": "El {attribute} debe tener menos que {value} artículos."
            },
            "lte": {
                "numeric": "El {attribute} debe ser menor o igual {value}.",
                "file": "El {attribute} debe ser menor o igual {value} kilobytes.",
                "string": "El {attribute} debe ser menor o igual {value} caracteres.",
                "array": "El {attribute} no debe tener más de {value} artículos."
            },
            "max": {
                "numeric": "El {attribute} no puede ser mayor que {max}.",
                "file": "El {attribute} no puede ser mayor que {max} kilobytes.",
                "string": "El {attribute} no puede ser mayor que {max} caracteres.",
                "array": "El {attribute} no puede tener más de {max} artículos.",
                "total": "El {attribute} no puede ser mayor que {max}."
            },
            "mimes": "El {attribute} must be a file of type: {values}.",
            "mimetypes": "Los {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "El campo {attribute} debe ser al menos de {min}.",
                "file": "El campo {attribute} debe ser al menos de {min} kilobytes.",
                "string": "El campo {attribute} debe ser al menos de {min} caracteres.",
                "array": "El campo {attribute} debe tener al menos {min} artículos."
            },
            "not_in": "El seleccionado {attribute} no es válido.",
            "not_regex": "El {attribute} formato no es válido.",
            "numeric": "El campo {attribute} tiene que ser un número.",
            "present": "El campo {attribute} debe estar presente.",
            "regex": "El campo {attribute} formato no es válido.",
            "required": "El campo {attribute} es requerido.",
            "required_if": "El campo {attribute} es requerido cuando {other} es {value}.",
            "required_unless": "El campo {attribute} es requerido a menos que {other} es en {values}.",
            "required_with": "El campo {attribute} es requerido cuando {values} esta presente.",
            "required_with_all": "El campo {attribute} es requerido cuando {values} esta presente.",
            "required_without": "El campo {attribute} es requerido cuando {values} no esta presente.",
            "required_without_all": "El campo {attribute} es requerido cuando ninguno de {values} estan presentes.",
            "same": "El campo {attribute} debe coincidir con {other}.",
            "size": {
                "numeric": "El {attribute} debe ser {size}.",
                "file": "El {attribute} debe ser {size} kilobytes.",
                "string": "El {attribute} debe ser {size} caracteres.",
                "array": "El {attribute} debe contener {size} artículos."
            },
            "string": "El {attribute} debe ser un texto.",
            "timezone": "El {attribute} debe ser una zona válida.",
            "unique": "El {attribute} ya se ha tomado.",
            "uploaded": "El {attribute} no se pudo cargar.",
            "url": "El {attribute} formato no válido.",
            "lenght": "Las {attribute} tienen demasiados caracteres",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verifica tu correo electrónico",
            "check_email": "Necesitamos verificar tu dirección de email",
            "check_email_label": "Consulta el correo electrónico para finalizar el registro. Te hemos enviado un enlace de registro a la dirección:",
            "resend_email": "¿No has recibido el enlace de registro? Volver a enviarlo",
            "resend_succesfully": "Reenviado satisfactoriamente",
            "reset_email": "Cambiar dirección de correo electrónico"
        },
        "welcome": {
            "subject": "Bienvenido a Controlla",
            "line_1": "Bienvenido.",
            "action": "Pruébalo ahora"
        }
    }
}
